const COLUMN_WIDTH: {
  [K in string]: number;
} = {
  name: 720,
  action: 50,
};

export { COLUMN_WIDTH };
